<template>
<b-card class="ml-4 mr-2 my-2 pb-2" :header="model.num">
  <b-row>
    <b-col>
      <return-status :websiteOrder="model" />
      Refunded: <strong style="color:red;">{{ model.refundedAmount | formatDollars }}</strong><br/>
      Submitted: <nice-date :value=model.createdAt /><br/>
      Approved: <nice-date :value=model.placedAt /><br class='mb-2'/>
      Item Total: {{ model.itemTotal | formatDollars }}<br/>
      <span v-if=showRestock>
        Restock Total: {{ model.restockingFee | formatDollars }}
      </span>
      <span v-else>
        Boo!
      </span><br/>
      Tax Total: {{ model.taxTotal | formatDollars }}<br/>
      <strong>Refund Total: {{ model.refundTotal | formatDollars }}</strong><br class='mt-1 mb-2'/>
      Notes: {{ model.notes }}<br/>
      <b-table :fields="fields" :items="model.items">
        <template slot="unitPrice" slot-scope="row">
          {{ row.item.unitPrice | formatDollars }}
        </template>
        <template slot="totalPrice" slot-scope="row">
          {{ row.item.totalPrice | formatDollars }}
        </template>
        <template slot="restockingFee" slot-scope="row">
          {{row.item.restockingFee | formatDollars }}
        </template>
      </b-table>
    </b-col>
  </b-row>

  <b-row class="mt-2 justify-content-center align-items-center" v-if="alert">
    <b-alert show class='mb-0'>{{alert}}</b-alert>
  </b-row>
  <b-row v-if="!orderExists && approved">
    <b-col>
      <b-row v-if="working" class="mt-2 justify-content-center align-items-center">
        <fingerprint-spinner :animation-duration="1500" :size="38" color="#293a93" />
      </b-row>
      <b-row  class="mt-2 justify-content-center align-items-center" v-else>
        Order does not exist in fishbowl!
        <div v-if="itAccess">
          <b-btn class='mx-2' @click="createChampReturn" variant="success">Recreate</b-btn>
        </div>
      </b-row>
    </b-col>
  </b-row>
  <b-row v-else-if="!orderExists && !approved">
    <b-col>
      <b-row>
        <b-col cols=*>
          <label for="shouldNotifyCheckbox">Notify Customer?</label>
          <b-form-checkbox id="shouldNotifyCheckbox" switch v-model="shouldNotify" />
        </b-col>
        <b-col>
          <b-form-input v-model="note" placeholder="Decline Note (sent to the customer)" />
        </b-col>
      </b-row>
      <b-row v-if="working" class="mt-2 justify-content-center align-items-center">
        <fingerprint-spinner :animation-duration="1500" :size="38" color="#293a93" />
      </b-row>
      <b-row class="mt-1 justify-content-center align-items-center" v-else>
        <!-- <b-btn class='mx-4' @click="approveReturn" variant="success">Approve</b-btn> -->
        <!-- <b-btn class='mx-4' @click="declineReturn" variant="danger">Decline</b-btn> -->
      </b-row>
    </b-col>
  </b-row>
</b-card>
</template>

<script>
import { FingerprintSpinner } from 'epic-spinners'

import ReturnStatus from '../sales-order/view-order-2/WebStatus'
import NiceDate from '../utility/NiceDate'
import { mapGetters } from 'vuex'

import ChampService from '../../services/champ'
import fishbowlService from '../../services/fishbowl'

export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    },
    approved: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FingerprintSpinner,
    ReturnStatus,
    NiceDate,
  },
  data() {
    return {
      fields: [
        { key: 'sku', label: 'SKU' },
        { key: 'returnReason' },
        { key: 'note' },
        { key: 'qty' },
        { key: 'refundedQuantity' },
        { key: 'unitPrice' },
        { key: 'totalPrice' },
        { key: 'restockingFee', },
      ],
      declineReasons: [
        { key: 'FINAL_SALE', label: 'The return contains FINAL SALE items' },
        { key: 'RETURN_PERIOD_ENDED', label: 'The return period has ended' },
        { key: 'OTHER', label: 'Some other reason (leave a note?)' },
      ],
      showRestock: true,
      alert: null,
      orderExists: true,
      reason: null,
      shouldNotify: true,
      note: null,
      working: false
    }
  },
  computed: {
    ...mapGetters({
      canAccess: 'canAccess',
    }),
    orderNum() {
      return this.order.name;
    },
    shopifyRmaNum() {
      return this.model.num;
    },
    fishbowlRmaNum() {
      return `R${this.orderNum}-${String.fromCharCode(parseInt(this.model.num.split('-').at(-1).substring(1)) + 64)}`
    },
    opsAccess() {
      return this.$store.getters.canAccess('ops-access')
    },
  },
  mounted() {
    fishbowlService.getSalesOrder(this.fishbowlRmaNum).then(r => {
      this.orderExists = (r.num === this.fishbowlRmaNum)
    }).catch(error => {
      console.error(error)
    })
  },
  methods: {
    createChampReturn(event) {
      if (!!event) {
        event.preventDefault()
      }

      if (this.note === undefined || this.note === null) {
        this.note = ""
      }

      let usingAmLabel = false;
      let address = this.model.shippingAddress;
      if (!address) address = this.model.billingAddress;
      address.carrier = usingAmLabel ? "FedEx Ground" : "Customer's Shipping Account"

      this.working = true;
      fishbowlService.getSalesOrder(this.orderNum).then(r => {
        let data = {
          orderNum: this.orderNum,
          address,
          lines: this.model.items.map(i => {
            let fbItems = r.items.filter(item => item.sku === i.sku && item.topParentId == null)
            let kitFlag = fbItems[0].kit;
            return {
              soItemId: fbItems[0].soItemId,
              num: i.returnReason,
              qty: parseInt(i.qty),
              items: [{
                id: fbItems[0].productId,
                num: i.sku,
                note: i.note,
                taxableFlag: fbItems[0].taxable,
                unitPrice: parseInt(i.unitPrice * 100.0),
                unitRestockPrice: parseInt(parseInt(i.restockingFee * 100.0) / parseInt(i.qty)), // commercebridge's restocking fee is TOTAL
                qty: parseInt(i.qty),
                kitFlag,
                type: kitFlag ? 80 : 20,
                affectStock: true,
                images: []
              }],
            };
          }),
          note: this.note,
          usingAmLabel,
          shippingLabelFee: 0,
          shippingRefund: 0,
          salesTaxRefund: parseInt(this.model.taxTotal * 100.0)
        };

        this.infoAuditLog('createRMA', event.target.innerText, this.orderNum, data, null);
        ChampService.submitRmaHc(data).then(r => {
          if (r.data) {
            this.checkChamp(r.data, () => {
              this.alert = "Success!";
              this.orderExists = true
              this.working = false
            }, data);
          } else {
            console.warn("CHAMP data", r);
            this.alert = "We had a problem adding the RMA to Fishbowl. Details have been logged to the console. Please summon an IT person to help investigate the problem";
            this.working = false
          }
        }).catch(error => {
          console.error(error);
          this.alert = "There was an error creating this RMA! Details have been logged to the console. Please summan an IT person to help investigate the problem";
          this.working = false
        })
      }).catch(error => {
        this.working = false
        console.error(error)
      })
    },
    checkChamp(id, callback, form) {
      ChampService.getCommandStatus(id).then((r) => {
        if (r.data.Processed) {
          if (r.data.ErrorCode === 1000) {
            callback()
          } else {
            console.log('CHAMP response data', r);
            this.alert = "We had a problem adding the RMA to Fishbowl. Details have been logged to the console. Please summon an IT person to help investigate the problem"
            this.working = false
          }
        } else {
          setTimeout(() => { this.checkChamp(id, callback, form); }, 2000);
        }
      });
    },

    approveReturn(event) {
      if (!!event) {
        event.preventDefault()
      }
      return

      this.working = true
      this.infoAuditLog('approveReturn', event.target.innerText, this.orderNum, null)
      shopifyService.approveReturn(this.model.orderID.split('/').at(-1), this.shouldNotify).then(response => {
        this.createChampReturn(event)
      }).catch((e) => {
        console.error(e)
        this.alert = "There was an error talking to Shopify - the return was NOT approved. Details have been logged to the console. Please summon an IT person to help investigate the problem"
        this.working = false
      })
    },
    declineReturn(event) {
      if (!!event) {
        event.preventDefault()
      }
      return

      this.working = true
      this.infoAuditLog('declineReturn', event.target.innerText, this.orderNum, null)
      shopifyService.declineReturn(this.model.orderId.split('/').at(-1), this.shouldNotify, this.reason, this.note).then(response => {
        this.alert = "Success!"
        this.working = false
      }).catch((e) => {
        console.error(e)
        this.alert = "There was an error talking to Shopify - the return was NOT declined. Details have been logged to the console. Please summon an IT person to help investigate the problem"
        this.working = false
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/rma-hc/RmaPendingLine.vue